import PropTypes from 'prop-types';
import { Select } from 'antd';
import * as React from 'react';
import stylePropType from 'react-style-proptype';
import { injectIntl } from 'react-intl';

const SelectOption = Select.Option;

class LeadScoringAttributeValueSelector extends React.Component {
  handleChange = (value) => {
    this.props.onChange(this.props.options.find(el => el.id === value));
  }

  render() {
    return (
      <Select
        onChange={this.handleChange}
        style={this.props.style}
        name={this.props.name}
        value={this.props.value}
        showSearch
        filterOption={(input, option) =>
          option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
        }
      >
        {this.props.options
          .filter((option) => { // do not show already selected values
            return this.props.skipValues.indexOf(String(option.id)) === -1;
          })
          .map((option, index) =>
            (<SelectOption key={index} value={option.id}>
              {option.label}
            </SelectOption>),
          )}
      </Select>
    );
  }
}

LeadScoringAttributeValueSelector.propTypes = {
  style: stylePropType,
  onChange: PropTypes.func,
  name: PropTypes.string,
  value: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
  ]),
  options: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.number,
    ]),
    label: PropTypes.string.isRequired,
  })),
  skipValues: PropTypes.arrayOf(PropTypes.string),
};

LeadScoringAttributeValueSelector.defaultProps = {
  style: { width: '100%' },
  selected: [],
};

export default injectIntl(LeadScoringAttributeValueSelector);



// WEBPACK FOOTER //
// ./src/components/LeadScoring/LeadScoringAttributeValueSelector/LeadScoringAttributeValueSelector.js